
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("gBjFV", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $946849c2df4a87c9$export$38ffae8c634274ba = (product, edition)=>{
    if (edition === 'standard') {
        if (product === 'jira' && (0, $dh538.fg)('edition_awareness_upsell_jira_fg')) return 'premium';
        if (product === 'jira-service-management' && (0, $dh538.fg)('edition_awareness_upsell_jsm_fg')) return 'premium';
        if (product === 'confluence' && (0, $dh538.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return 'premium';
        if (product === 'jira-product-discovery' && (0, $dh538.fg)('upsell_edition_awareness_jpd_fg')) return 'premium';
    }
    return 'standard';
};
module.exports["getTrialOfferingName"] = $946849c2df4a87c9$export$38ffae8c634274ba;

});

parcelRegister("h0D5V", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $d84b3820568fba5b$export$d58c0da339bf36d9({ product: product, edition: edition, userRoles: userRoles, trialOfferingName: trialOfferingName }) {
    if (edition === 'standard' && userRoles?.includes('SITE_ADMIN') && trialOfferingName === 'premium') {
        if (product === 'jira' && (0, $dh538.fg)('edition_awareness_upsell_jira_fg')) return true;
        if (product === 'jira-service-management' && (0, $dh538.fg)('edition_awareness_upsell_jsm_fg')) return true;
        if (product === 'confluence' && (0, $dh538.fg)('edition_awareness_standard_upsell_confluence_ab_fg')) return true;
        if (product === 'jira-product-discovery' && (0, $dh538.fg)('upsell_edition_awareness_jpd_fg')) return true;
    }
    return false;
}
module.exports["isEligibleForStandardToPremium"] = $d84b3820568fba5b$export$d58c0da339bf36d9;

});

parcelRegister("ecqMk", function(module, exports) {
const $0a0029952ec94989$var$ProductKeyToHAMSMap = {
    ['confluence']: 'confluence',
    ['jira']: 'jira-software',
    ['jira-product-discovery']: 'jira-product-discovery',
    ['jira-service-management']: 'jira-servicedesk'
};
const $0a0029952ec94989$export$291d012eb0744b34 = (product)=>{
    return $0a0029952ec94989$var$ProductKeyToHAMSMap[product];
};
module.exports["getHamsKey"] = $0a0029952ec94989$export$291d012eb0744b34;

});

parcelRegister("fVYKU", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $fAD9L = parcelRequire("fAD9L");


var $7wGk4 = parcelRequire("7wGk4");


var $gLwIY = parcelRequire("gLwIY");


var $70Blk = parcelRequire("70Blk");


var $4hFod = parcelRequire("4hFod");


var $aKQ5r = parcelRequire("aKQ5r");








var $irOoi = parcelRequire("irOoi");


var $iP9n7 = parcelRequire("iP9n7");


var $cQDYl = parcelRequire("cQDYl");


var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");


var $eyWa4 = parcelRequire("eyWa4");


var $4M6GB = parcelRequire("4M6GB");


var $TSbNa = parcelRequire("TSbNa");


var $7wYo8 = parcelRequire("7wYo8");


var $48FEk = parcelRequire("48FEk");


var $gWF6I = parcelRequire("gWF6I");

const $f40deda643f957f4$var$emptyEntryPointParams = {};
const $f40deda643f957f4$var$emptyEntryPointProps = {};
function $f40deda643f957f4$export$beb58c00994cbd66({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, Fallback: Fallback, title: title, modalProps: modalProps, forwardedRef: forwardedRef, onError: onError, shouldAutoOpen: shouldAutoOpen, preloadOnFocus: preloadOnFocus = false }) {
    const { openModal: openModal } = (0, $42omo.useContext)((0, $TSbNa.ModalContext));
    const environmentProvider = (0, $gWF6I.useRelayEnvironmentProvider)();
    const { ModalErrorFallback: ModalErrorFallback } = (0, $4M6GB.useEntryPointConfig)();
    const metricName = (0, $42omo.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $42omo.useCallback)(()=>(0, $irOoi.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f40deda643f957f4$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $42omo.useCallback)(({ reference: entryPointReference, dispose: dispose })=>{
        openModal(({ onClose: closeModal, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick, shouldCloseOnEscapePress: shouldCloseOnEscapePress, setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick, setShouldCloseOnEscapePress: setShouldCloseOnEscapePress })=>{
            const onClose = (extraInformation)=>{
                entryPointProps?.onClose?.(extraInformation);
                closeModal();
                dispose();
            };
            const defaultFallback = /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $9ot3w.default), {
                        hasCloseButton: true,
                        children: title ? /*#__PURE__*/ (0, $l998X.jsx)((0, $d8eRd.default), {
                            children: title
                        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                            grow: "fill",
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $l998X.jsxs)((0, $1DHa6.default), {
                        children: [
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {}),
                            /*#__PURE__*/ (0, $l998X.jsx)((0, $cQDYl.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $8o1lj.default), {})
                ]
            });
            const container = /*#__PURE__*/ (0, $l998X.jsx)((0, $48FEk.InternalEntryPointContainer), {
                entryPointReference: entryPointReference,
                errorFallback: ({ error: error })=>/*#__PURE__*/ (0, $l998X.jsx)(ModalErrorFallback, {
                        error: error
                    }),
                onError: ({ error: error, errorInfo: errorInfo })=>{
                    onError?.({
                        error: error,
                        errorInfo: errorInfo
                    });
                    closeModal();
                },
                fallback: Fallback ? /*#__PURE__*/ (0, $l998X.jsx)(Fallback, {
                    onClose: closeModal
                }) : defaultFallback,
                id: metricName,
                placeholderName: "modal-entry-point-pressable-trigger-container",
                runtimeProps: {
                    ...entryPointProps ?? $f40deda643f957f4$var$emptyEntryPointProps,
                    onClose: onClose,
                    setShouldCloseOnOverlayClick: setShouldCloseOnOverlayClick,
                    setShouldCloseOnEscapePress: setShouldCloseOnEscapePress,
                    shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
                    shouldCloseOnEscapePress: shouldCloseOnEscapePress
                }
            });
            return /*#__PURE__*/ (0, $l998X.jsx)((0, $8CZUH.default), {
                ...modalProps,
                onClose: onClose,
                shouldCloseOnOverlayClick: shouldCloseOnOverlayClick ?? modalProps?.shouldCloseOnOverlayClick,
                shouldCloseOnEscapePress: shouldCloseOnEscapePress ?? modalProps?.shouldCloseOnEscapePress,
                children: container
            });
        });
    }, [
        openModal,
        title,
        modalProps,
        Fallback,
        metricName,
        entryPointProps,
        ModalErrorFallback,
        onError
    ]);
    const triggerRef = (0, $7wYo8.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad,
        preloadOnFocus: preloadOnFocus
    });
    const mergedRef = (0, $iP9n7.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    const hasRun = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (!hasRun.current && shouldAutoOpen) {
            hasRun.current = true;
            const reference = load();
            onLoad({
                reference: reference,
                dispose: reference.dispose
            });
        }
    }, [
        shouldAutoOpen,
        load,
        onLoad
    ]);
    // -- UNIQUE CODE FOR AUTO LOADING
    return children({
        ref: mergedRef
    });
}


function $3419347acdf26ff2$export$50a5ec7edfae079b(props) {
    const { dialogConfig: dialogConfig, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gLwIY.DialogContext).Provider, {
        value: dialogConfig,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bYRk6.default), {
            data: dialogConfig,
            children: /*#__PURE__*/ (0, $l998X.jsx)($3419347acdf26ff2$var$ModalEntryPointInner, {
                ...rest
            })
        })
    });
}
function $3419347acdf26ff2$var$ModalEntryPointInner(props) {
    const { shouldAutoOpen: shouldAutoOpen, entryPointProps: entryPointProps, onError: onError, ...rest } = props;
    const onEntrypointError = (0, $70Blk.useEntrypointErrorAnalytics)();
    const onErrorCallback = (0, $42omo.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        onEntrypointError({
            error: error,
            errorInfo: errorInfo
        });
        onError?.({
            error: error,
            errorInfo: errorInfo
        });
    }, [
        onEntrypointError,
        onError
    ]);
    const onCloseDialog = (0, $4hFod.useOnCloseDialog)();
    const onClose = (0, $42omo.useCallback)((extraInformation)=>{
        let attributes;
        if (extraInformation && typeof extraInformation === 'object' && 'triggeredBy' in extraInformation) attributes = {
            triggeredBy: extraInformation.triggeredBy
        };
        onCloseDialog(attributes);
        entryPointProps?.onClose?.();
    }, [
        entryPointProps,
        onCloseDialog
    ]);
    const finalEntryPointProps = (0, $42omo.useMemo)(()=>({
            ...entryPointProps,
            onClose: onClose
        }), [
        entryPointProps,
        onClose
    ]);
    // If we're auto opening, we can handle this setting here
    const Trigger = shouldAutoOpen ? (0, $f40deda643f957f4$export$beb58c00994cbd66) : (0, $7wGk4.ModalTrigger);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fAD9L.ModalContextProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)(Trigger, {
            ...rest,
            entryPointProps: finalEntryPointProps,
            onError: onErrorCallback,
            shouldAutoOpen: shouldAutoOpen,
            preloadOnFocus: true,
            children: ({ ref: ref })=>{
                return /*#__PURE__*/ (0, $l998X.jsx)((0, $aKQ5r.EditionAwarenessButton), {
                    ref: ref
                });
            }
        })
    });
}
module.exports["ModalEntryPoint"] = $3419347acdf26ff2$export$50a5ec7edfae079b;

});

parcelRegister("gLwIY", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $8cdcd158356ed598$export$8b93a07348a7730c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $8cdcd158356ed598$export$898e461c0669e62d() {
    return (0, $42omo.useContext)($8cdcd158356ed598$export$8b93a07348a7730c);
}
module.exports["DialogContext"] = $8cdcd158356ed598$export$8b93a07348a7730c;
module.exports["useDialogContext"] = $8cdcd158356ed598$export$898e461c0669e62d;

});

parcelRegister("70Blk", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $ac7kz = parcelRequire("ac7kz");

function $e3ebf0d7bad26c5e$export$f2e26e89f653216c() {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const handleOnError = (0, $42omo.useCallback)(({ error: error, errorInfo: errorInfo })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: {
                error: error.message,
                errorStack: error.stack,
                errorName: error.name,
                errorComponentStack: errorInfo.componentStack,
                id: 'entrypointError'
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    return handleOnError;
}
module.exports["useEntrypointErrorAnalytics"] = $e3ebf0d7bad26c5e$export$f2e26e89f653216c;

});

parcelRegister("4hFod", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lvsjl = parcelRequire("lvsjl");


var $ac7kz = parcelRequire("ac7kz");

const $65c23a972b305e4f$export$bdf52d4393ceb609 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const onClose = (0, $42omo.useCallback)((attributes)=>{
        sendAnalyticsEvent({
            action: 'closed',
            actionSubject: 'dialog',
            actionSubjectId: 'editionAwarenessDialog',
            attributes: attributes
        });
    }, [
        sendAnalyticsEvent
    ]);
    const [onCloseDebounced] = (0, $lvsjl.default)(onClose, 300, {
        leading: true,
        trailing: false
    });
    return onCloseDebounced;
};
module.exports["useOnCloseDialog"] = $65c23a972b305e4f$export$bdf52d4393ceb609;

});

parcelRegister("aKQ5r", function(module, exports) {
/* edition-awareness-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");

var $8C5kA = parcelRequire("8C5kA");


var $1Whri = parcelRequire("1Whri");


var $izVB4 = parcelRequire("izVB4");


var $i3uiK = parcelRequire("i3uiK");


var $9VJDA = parcelRequire("9VJDA");


var $ebrpi = parcelRequire("ebrpi");


var $2Nwuj = parcelRequire("2Nwuj");


var $aaBfd = parcelRequire("aaBfd");


var $efXed = parcelRequire("efXed");


var $5izcQ = parcelRequire("5izcQ");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");

var $gdv5Z = parcelRequire("gdv5Z");

var $1s5hv = parcelRequire("1s5hv");

var $fVUfS = parcelRequire("fVUfS");

var $eyWa4 = parcelRequire("eyWa4");

var $iXCQx = parcelRequire("iXCQx");


var $irxfF = parcelRequire("irxfF");

var $2zUpm = parcelRequire("2zUpm");

var $3ylo6 = parcelRequire("3ylo6");

var $hEz36 = parcelRequire("hEz36");





var $ac7kz = parcelRequire("ac7kz");

function $026520e0abbadaad$export$d0a9edec5c713764({ actionSubjectId: actionSubjectId, actionSubject: actionSubject, attributes: attributes }) {
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const hasSent = (0, $42omo.useRef)(false);
    (0, $42omo.useEffect)(()=>{
        if (hasSent.current) return;
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: attributes
        });
        hasSent.current = true;
    }, [
        sendAnalyticsEvent,
        actionSubject,
        actionSubjectId,
        attributes
    ]);
    return null;
}











const $f9c9e1f12d93897c$export$d840cf3018e72a62 = ()=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    return (0, $42omo.useCallback)((dismissMenuIntent)=>{
        sendAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'editionAwarenessDismissMenu',
            attributes: {
                dismissMenuIntent: dismissMenuIntent
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
};



var $eoBBJ = parcelRequire("eoBBJ");


var $dv2kx = parcelRequire("dv2kx");


var $gBjFV = parcelRequire("gBjFV");


var $fcmKV = parcelRequire("fcmKV");








var $6m14E = parcelRequire("6m14E");


var $7iPhi = parcelRequire("7iPhi");








var $fTb0L = parcelRequire("fTb0L");


var $59Upg = parcelRequire("59Upg");


var $7cyOE = parcelRequire("7cyOE");


var $4WriN = parcelRequire("4WriN");


var $h0D5V = parcelRequire("h0D5V");


var $3uYxt = parcelRequire("3uYxt");

// TODO: `licensedUserLimit` should be fetched from the server
const $a9f25d7cdaed579f$var$PRODUCT_LIMITS_MAP = {
    'jira-product-discovery': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    },
    jira: {
        licensedUserLimit: 10,
        warningUserLimit: 7
    },
    confluence: {
        licensedUserLimit: 10,
        warningUserLimit: 3
    },
    'jira-service-management': {
        licensedUserLimit: 3,
        warningUserLimit: 2
    }
};
function $a9f25d7cdaed579f$var$getFreeContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue }) {
    const { licensedUsers: licensedUsers, product: product, automationFreeLimitStatus: automationFreeLimitStatus } = context;
    const limits = $a9f25d7cdaed579f$var$PRODUCT_LIMITS_MAP[product];
    const upgradeText = formatMessage({
        id: "@atlassian/edition-awareness.button.upgrade",
        defaultMessage: "Upgrade"
    });
    // Put at the top because we are expanding the audience and we need to be sure this check is done first
    if ((0, $59Upg.isEligibleForConfluenceEndUserRequestExperiment)(context)) return {
        text: upgradeText,
        appearance: 'default',
        icon: 'gem'
    };
    // Is eligible for automation limits
    if ((0, $dh538.fg)('twcg-1076_jira_automation_limits_kill_switch')) {
        if (automationFreeLimitStatus) {
            if (automationFreeLimitStatus === 'BREACHED' && getExperimentValue({
                statsigParams: {
                    experimentName: 'twcg-1076_jira_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                }
            }) === 'variation') return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.automation-limits-breached",
                    defaultMessage: "Limit reached"
                }),
                appearance: 'danger',
                icon: 'warning'
            };
            if (automationFreeLimitStatus === 'PROJECTED_TO_BREACH' && getExperimentValue({
                statsigParams: {
                    experimentName: 'twcg-1076_jira_automation_limits_experiment',
                    parameterName: 'cohort',
                    defaultValue: 'not-enrolled'
                }
            }) === 'variation') // If the automation usage is projected to breach, we show a warning
            return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.automation-near-limit",
                    defaultMessage: "Near limit"
                }),
                appearance: 'warning',
                icon: 'warning'
            };
        }
    }
    if ((0, $7iPhi.isEligibleForStorageHardLimit)(context)) return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.storage-hard-limit",
            defaultMessage: "Storage full"
        }),
        appearance: 'warning',
        icon: 'warning'
    };
    if ((0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        if (licensedUsers >= limits.licensedUserLimit) return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.no-users-left",
                defaultMessage: "No {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left"
            }, {
                product: (0, $6m14E.getProductForTranslation)(product)
            }),
            appearance: product !== 'confluence' ? 'danger' : 'warning',
            icon: 'warning'
        };
        if (licensedUsers >= limits.warningUserLimit) return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.limited-users-left",
                defaultMessage: "Limited {product, select, jpd {creators} jsm {agents} jira {users} confluence {users} other {users}} left"
            }, {
                product: (0, $6m14E.getProductForTranslation)(product)
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if (product === 'confluence' && licensedUsers >= limits.warningUserLimit) // Confluence has its own variety when compared to the `userLimits` feature
    return {
        text: upgradeText,
        appearance: 'warning',
        icon: 'warning'
    };
    return {
        text: upgradeText,
        appearance: 'default',
        icon: 'gem'
    };
}
function $a9f25d7cdaed579f$var$getTrialContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue }) {
    const { product: product, edition: edition, trialDaysLeft: trialDaysLeft, trialLengthDays: trialLengthDays, isInReverseTrial: isInReverseTrial, userRoles: userRoles } = context;
    let appearance = 'default';
    let icon = 'gem';
    const daysLeftText = formatMessage({
        id: "@atlassian/edition-awareness.button.daysLeft",
        defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left"
    }, {
        trialDaysLeft: trialDaysLeft
    });
    const isInFirstHalfOfTrial = Boolean(trialDaysLeft && trialLengthDays && trialDaysLeft > Math.ceil(trialLengthDays / 2));
    if (edition === 'premium' && product === 'jira' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $dh538.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') {
            appearance = 'default';
            icon = 'gem';
            if (isInFirstHalfOfTrial) return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.see-plans",
                    defaultMessage: "See plans"
                }),
                appearance: appearance,
                icon: icon
            };
            if (trialDaysLeft && trialDaysLeft <= 3) {
                appearance = 'warning';
                icon = 'warning';
            }
            return {
                text: daysLeftText,
                appearance: appearance,
                icon: icon
            };
        }
    }
    if ((0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'jira-service-management',
        'jira-product-discovery'
    ])) {
        // If trial is still in its first half, show trial message instead of trial days left
        if (isInFirstHalfOfTrial) {
            if (edition === 'premium') return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.premium-trial",
                    defaultMessage: "Premium trial"
                }),
                appearance: appearance,
                icon: icon
            };
            if (edition === 'standard') return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.standard-trial",
                    defaultMessage: "Standard trial"
                }),
                appearance: appearance,
                icon: icon
            };
        }
        // If trial has 3 days or less remaining, swap the button to the warning state
        if (trialDaysLeft && trialDaysLeft <= 3) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if ((0, $7cyOE.isEligibleForManualFeatureOnboarding)(context) && getExperimentValue({
        statsigParams: {
            experimentName: 'manual_trial_w_pde_onboarding',
            parameterName: 'cohort',
            defaultValue: 'not-enrolled'
        }
    }) === 'variation') return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.explore-edition",
            defaultMessage: "Explore {edition, select, premium {Premium} standard {Standard} other {Trial}}"
        }, {
            edition: edition
        }),
        appearance: 'default',
        icon: 'gem'
    };
    if ((0, $fTb0L.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $dh538.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'use-button-content getTrialContent'
                }
            }
        });
        if (abCohort === 'variation') {
            appearance = 'default';
            icon = 'gem';
            if (trialDaysLeft && trialDaysLeft > 15) return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.see-plans.cbrt",
                    defaultMessage: "See plans"
                }),
                appearance: appearance,
                icon: icon
            };
            if (trialDaysLeft && trialDaysLeft <= 3) {
                appearance = 'warning';
                icon = 'warning';
            }
            return {
                text: formatMessage({
                    id: "@atlassian/edition-awareness.button.see-plans.cbrt.final",
                    // eslint-disable-next-line @atlassian/i18n/enforce-plural-rules
                    defaultMessage: "{trialDaysLeft, plural, =1 {# day} other {# days}} left"
                }, {
                    trialDaysLeft: trialDaysLeft
                }),
                appearance: appearance,
                icon: icon
            };
        }
    }
    return {
        text: daysLeftText,
        appearance: appearance,
        icon: icon
    };
}
function $a9f25d7cdaed579f$var$getPredunningContent({ context: context, formatMessage: formatMessage, getExperimentValue: getExperimentValue }) {
    const { edition: edition, product: product, isInReverseTrial: isInReverseTrial, userRoles: userRoles } = context;
    let appearance = 'default';
    let icon = 'credit-card';
    if (product === 'jira' && edition === 'premium' && isInReverseTrial && userRoles?.includes('BILLING_ADMIN') && (0, $dh538.fg)('jira_reverse_trial_ea_updates_during_trial_gate')) {
        if (getExperimentValue({
            statsigParams: {
                experimentName: 'jira_reverse_trial_ea_updates_during_trial',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            }
        }) === 'variation') return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.choose-plans",
                defaultMessage: "Choose a plan"
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    if ((0, $fTb0L.isEligibleForConfluenceBuyReverseTrialExperiment)(context) && (0, $dh538.fg)('growth_confluence_buy_reverse_trials_fg')) {
        const abCohort = getExperimentValue({
            statsigParams: {
                experimentName: 'growth_confluence_buy_reverse_trials_ab',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'luna',
                trackEventAttributes: {
                    touchpointId: 'use-button-content getPredunningContent'
                }
            }
        });
        if (abCohort === 'variation') return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.see-plans.final",
                defaultMessage: "Choose a plan"
            }),
            appearance: 'warning',
            icon: 'warning'
        };
    }
    return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.addPaymentDetails",
            defaultMessage: "Add payment details"
        }),
        appearance: appearance,
        icon: icon
    };
}
function $a9f25d7cdaed579f$var$getCollectionContent({ context: context, formatMessage: formatMessage }) {
    /* ==============================
  // Collection
  // Collection handles its own logic for the button content
  // This is to avoid the button content from being overridden by other products' logic
  // ============================== */ const { isInTrial: isInTrial, trialDaysLeft: trialDaysLeft, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails } = context;
    if (isInTrial) {
        let appearance = 'default';
        let icon = 'gem';
        const daysLeftText = formatMessage({
            id: "@atlassian/edition-awareness.button.collection.daysLeft",
            defaultMessage: "{trialDaysLeft, plural, one {# day} other {# days}} left"
        }, {
            trialDaysLeft: trialDaysLeft
        });
        if (trialDaysLeft && trialDaysLeft <= 3 && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails) {
            appearance = 'warning';
            icon = 'warning';
        }
        return {
            text: daysLeftText,
            appearance: appearance,
            icon: icon
        };
    }
    if (isInPredunning) {
        if (canAddPaymentDetails && invoiceableStatus === 'NOT_INVOICEABLE') return {
            text: formatMessage({
                id: "@atlassian/edition-awareness.button.collection.addPaymentDetails",
                defaultMessage: "Add payment details"
            }),
            appearance: 'default',
            icon: 'gem'
        };
    }
    return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.collection.upgrade",
            defaultMessage: "Upgrade"
        }),
        appearance: 'default',
        icon: 'gem'
    };
}
function $a9f25d7cdaed579f$export$c810aba6284fa97d() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const { edition: edition, isInPredunning: isInPredunning, isInTrial: isInTrial, isInCollection: isInCollection, product: product } = context;
    /*
   * Keep this before the other checks to avoid showing the collection content in the other cases
   */ if (isInCollection && (0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ])) return $a9f25d7cdaed579f$var$getCollectionContent({
        context: context,
        formatMessage: formatMessage
    });
    if (edition === 'free') return $a9f25d7cdaed579f$var$getFreeContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue
    });
    if (isInTrial) return $a9f25d7cdaed579f$var$getTrialContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue
    });
    if (isInPredunning) return $a9f25d7cdaed579f$var$getPredunningContent({
        context: context,
        formatMessage: formatMessage,
        getExperimentValue: getExperimentValue
    });
    if ((0, $4WriN.isEligibleForServCoUplift)(context)) return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.try-service-collection",
            defaultMessage: "Try Service Collection"
        }),
        appearance: 'default',
        icon: 'gem'
    };
    if ((0, $h0D5V.isEligibleForStandardToPremium)(context)) return {
        text: formatMessage({
            id: "@atlassian/edition-awareness.button.upgrade.standard-to-premium",
            defaultMessage: "Upgrade"
        }),
        appearance: 'default',
        icon: 'gem',
        isDismissible: true
    };
    return null;
}



var $e2ROq = parcelRequire("e2ROq");


var $hT0Mj = parcelRequire("hT0Mj");

const $b0c1c91ea364c712$export$c36573823bda97dd = 'edition-awareness';
const $b0c1c91ea364c712$var$styles = {
    button: "_11c8fhey _2rko12b0 _zulpu2gc _4bfu1r31 _1hmsglyw _ajmmnqa1 _189ee4h9 _1dqonqa1 _18zrutpp _1rjc1b66 _k48p1wq8 _bfhkvuon _1tkezwfg _syazi7uo _k8m0t8hk _1oecfnf5 _1e0c1txw _4cvr1h6o _1a3b1r31 _4fprglyw _5goinqa1 _f8pji7uo _9oik1r31 _1bnxglyw _jf4cnqa1 _irr31dpa _30l3i7uo _1nrm1r31 _c2waglyw _1iohnqa1 _1di6fcek",
    buttonT26Shape: "_2rko1qi0",
    default: "_1h6dv30g _syazdv2p _f8pjdv2p _irr3kca2 _30l3dv2p _1di61jbm",
    warning: "_1h6d1xiv",
    danger: "_1h6d1bqt",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _uiztglyw",
    dismissible: "_qrwqidpf _1o0zidpf",
    dismissMenu: "_11c8fhey _2rko12b0 _zulpu2gc _4bfu1r31 _1hmsglyw _ajmmnqa1 _189ee4h9 _1dqonqa1 _18zru2gc _1rjcze3t _1h6dv30g _k48p1wq8 _bfhkvuon _1tkezwfg _syazi7uo _k8m0t8hk _1oecfnf5 _1e0c1txw _4cvr1h6o _t6vdidpf _13liidpf _mrkbidpf _irr3kca2 _1di61jbm",
    dismissMenuT26Shape: "_2rko1qi0 _13liidpf _mrkbidpf",
    reasonsUl: "_19pkidpf _18u0pxbi _19bvu2gc"
};
function $b0c1c91ea364c712$var$Icon({ appearance: appearance, icon: icon, color: color }) {
    if (icon === 'warning') {
        const defaultColor = appearance === 'danger' ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon-warning, #E06C00)";
        return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ebrpi))), {
            label: "",
            color: color ?? defaultColor,
            size: "small"
        });
    }
    if (icon === 'credit-card') return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i3uiK))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)"
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($izVB4))), {
        label: "",
        color: color ?? "var(--ds-icon-discovery, #AF59E1)"
    });
}
const $b0c1c91ea364c712$export$57ddd9301662f8e4 = /*#__PURE__*/ (0, $42omo.forwardRef)(function({ onClick: onClick, ...rest }, ref) {
    const buttonContent = (0, $a9f25d7cdaed579f$export$c810aba6284fa97d)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default', isDismissible: isDismissible, isEducationDiscount: isEducationDiscount } = buttonContent;
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const context = (0, $eoBBJ.useEditionAwareness)();
    const { getExperimentValue: getExperimentValue } = (0, $dv2kx.useGetExperimentValue)();
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            type: 'button',
            icon: icon,
            appearance: appearance,
            isEducationDiscount: isEducationDiscount
        }), [
        icon,
        appearance,
        isEducationDiscount
    ]);
    const handleOnClick = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent); // Fire exposure for ea_to_osb_experiment control tenants
        if ((0, $fcmKV.isEligibleForEAtoOSBExperiment)(context)) getExperimentValue({
            statsigParams: {
                experimentName: 'ea_to_osb_experiment',
                parameterName: 'cohort',
                defaultValue: 'not-enrolled'
            },
            trackEventParameters: {
                trackEventGrowthInitiative: 'tako'
            }
        });
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes,
        getExperimentValue,
        context
    ]);
    const handleOnMouseEnter = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    const Button = hasCustomTheme ? // When there's a custom theme applied we just return a button which gets styled by the theme
    /*#__PURE__*/ (0, $l998X.jsxs)((0, $aaBfd.Button), {
        ...rest,
        ref: ref,
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)($b0c1c91ea364c712$var$Icon, {
                appearance: appearance,
                icon: icon,
                color: "currentColor"
            }),
        children: [
            text,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $026520e0abbadaad$export$d0a9edec5c713764), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    }) : /*#__PURE__*/ (0, $l998X.jsxs)((0, $fVUfS.default), {
        ...rest,
        ref: ref,
        xcss: (0, $1Whri.cx)($b0c1c91ea364c712$var$styles.button, (0, $dh538.fg)('platform-dst-shape-theme-default') && $b0c1c91ea364c712$var$styles.buttonT26Shape, appearance === 'default' && $b0c1c91ea364c712$var$styles.default, appearance === 'warning' && $b0c1c91ea364c712$var$styles.warning, appearance === 'danger' && $b0c1c91ea364c712$var$styles.danger, isDismissible && $b0c1c91ea364c712$var$styles.dismissible),
        onClick: handleOnClick,
        onMouseEnter: handleOnMouseEnter,
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                xcss: $b0c1c91ea364c712$var$styles.icon,
                children: /*#__PURE__*/ (0, $l998X.jsx)($b0c1c91ea364c712$var$Icon, {
                    appearance: appearance,
                    icon: icon
                })
            }),
            text,
            /*#__PURE__*/ (0, $l998X.jsx)((0, $026520e0abbadaad$export$d0a9edec5c713764), {
                actionSubjectId: "editionAwareness",
                actionSubject: "button",
                attributes: analyticsAttributes
            })
        ]
    });
    if (isDismissible) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
        name: $b0c1c91ea364c712$export$c36573823bda97dd,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            alignItems: "center",
            children: [
                Button,
                /*#__PURE__*/ (0, $l998X.jsx)($b0c1c91ea364c712$var$DismissMenu, {})
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
        name: $b0c1c91ea364c712$export$c36573823bda97dd,
        children: Button
    });
});
const $b0c1c91ea364c712$export$1bf8122badfd728c = /*#__PURE__*/ (0, $42omo.forwardRef)(function({ onClick: onClick, href: href, touchpointIntent: touchpointIntent, linkId: linkId, ...rest }, ref) {
    const buttonContent = (0, $a9f25d7cdaed579f$export$c810aba6284fa97d)();
    if (buttonContent === null) throw new Error('The button content is null, please check the context');
    const { text: text, icon: icon, appearance: appearance = 'default' } = buttonContent;
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $ac7kz.useAnalytics)();
    const { origin: origin, url: tracedUrl } = (0, $e2ROq.useTracedUrl)(href);
    if (!tracedUrl) throw new Error('The link url is undefined, please check the context');
    const analyticsAttributes = (0, $42omo.useMemo)(()=>({
            type: 'link',
            icon: icon,
            appearance: appearance,
            touchpointIntent: touchpointIntent,
            linkId: linkId,
            ...origin.toAnalyticsAttributes()
        }), [
        icon,
        appearance,
        touchpointIntent,
        linkId,
        origin
    ]);
    const handleOnClick = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        onClick?.(e, analyticsEvent);
        const updatedAnalyticsEvent = analyticsEvent.update((payload)=>({
                ...payload,
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'editionAwareness',
                attributes: analyticsAttributes
            }));
        sendAnalyticsEvent(updatedAnalyticsEvent);
    }, [
        onClick,
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    const handleOnMouseEnter = (0, $42omo.useCallback)(()=>{
        sendAnalyticsEvent({
            eventType: 'ui',
            action: 'hovered',
            actionSubject: 'button',
            actionSubjectId: 'editionAwareness',
            attributes: analyticsAttributes
        });
    }, [
        sendAnalyticsEvent,
        analyticsAttributes
    ]);
    if (hasCustomTheme) // When there's a custom theme applied we just return a button which gets styled by the theme
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
        name: $b0c1c91ea364c712$export$c36573823bda97dd,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $aaBfd.LinkButton), {
            ...rest,
            href: tracedUrl,
            ref: ref,
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            iconBefore: ()=>/*#__PURE__*/ (0, $l998X.jsx)($b0c1c91ea364c712$var$Icon, {
                    appearance: appearance,
                    icon: icon,
                    color: "currentColor"
                }),
            children: [
                text,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $026520e0abbadaad$export$d0a9edec5c713764), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5izcQ.default), {
        name: $b0c1c91ea364c712$export$c36573823bda97dd,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
            ...rest,
            href: tracedUrl,
            ref: ref,
            xcss: (0, $1Whri.cx)($b0c1c91ea364c712$var$styles.button, (0, $dh538.fg)('platform-dst-shape-theme-default') && $b0c1c91ea364c712$var$styles.buttonT26Shape, appearance === 'default' && $b0c1c91ea364c712$var$styles.default, appearance === 'warning' && $b0c1c91ea364c712$var$styles.warning, appearance === 'danger' && $b0c1c91ea364c712$var$styles.danger),
            onClick: handleOnClick,
            onMouseEnter: handleOnMouseEnter,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                    xcss: $b0c1c91ea364c712$var$styles.icon,
                    children: /*#__PURE__*/ (0, $l998X.jsx)($b0c1c91ea364c712$var$Icon, {
                        appearance: appearance,
                        icon: icon
                    })
                }),
                text,
                /*#__PURE__*/ (0, $l998X.jsx)((0, $026520e0abbadaad$export$d0a9edec5c713764), {
                    actionSubjectId: "editionAwareness",
                    actionSubject: "button",
                    attributes: analyticsAttributes
                })
            ]
        })
    });
});
const $b0c1c91ea364c712$var$capitalizeName = (name)=>name.split(' ').map((word)=>{
        return word[0].toUpperCase() + word.substring(1);
    }).join(' ');
function $b0c1c91ea364c712$var$DismissMenu() {
    const { formatMessage: formatMessage } = (0, $8C5kA.default)();
    const fireDismissMenuEvent = (0, $f9c9e1f12d93897c$export$d840cf3018e72a62)();
    const { product: product, edition: edition, onDismissButton: onDismissButton } = (0, $eoBBJ.useEditionAwareness)();
    const { setActiveSpotlight: setActiveSpotlight } = (0, $hT0Mj.useSpotlight)();
    const hasCustomTheme = (0, $efXed.useHasCustomTheme)();
    const trialOfferingName = (0, $gBjFV.getTrialOfferingName)(product, edition);
    const handleOnEvents = (0, $42omo.useCallback)((e)=>{
        if (e.type === 'DISMISS_SUCCEEDED' && onDismissButton) {
            onDismissButton();
            fireDismissMenuEvent('dismiss');
            setActiveSpotlight('standard-to-premium');
        }
        if (e.type === 'AD_CONTROL_DROP_DOWN_MENU_OPENED') fireDismissMenuEvent('openMenu');
        if (e.type === 'REASONS_BUTTON_CLICKED') fireDismissMenuEvent('learnMore');
    }, [
        onDismissButton,
        setActiveSpotlight,
        fireDismissMenuEvent
    ]);
    const dismissMenuAriaLabel = formatMessage({
        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.menu-aria",
        defaultMessage: "More"
    });
    const getAdControlsTrigger = (0, $42omo.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ triggerRef: triggerRef, ...props })=>{
        return hasCustomTheme ? /*#__PURE__*/ (0, $l998X.jsx)((0, $aaBfd.IconButton), {
            ...props,
            ref: triggerRef,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))),
            "aria-label": dismissMenuAriaLabel
        }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
            ...props,
            ref: triggerRef,
            xcss: (0, $1Whri.cx)($b0c1c91ea364c712$var$styles.dismissMenu, (0, $dh538.fg)('platform-dst-shape-theme-default') && $b0c1c91ea364c712$var$styles.dismissMenuT26Shape),
            "aria-label": dismissMenuAriaLabel,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9VJDA))), {
                label: "",
                spacing: "none",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            })
        });
    }, [
        hasCustomTheme,
        dismissMenuAriaLabel
    ]);
    const offering = /*#__PURE__*/ (0, $l998X.jsxs)((0, $iXCQx.default), {
        weight: "bold",
        children: [
            $b0c1c91ea364c712$var$capitalizeName(product.replace(/-/g, ' ')),
            " ",
            $b0c1c91ea364c712$var$capitalizeName(trialOfferingName)
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $2zUpm.default), {
        onEvents: (e)=>handleOnEvents(e),
        shouldShowDismissFlag: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $irxfF.default), {
            itemId: "default-item",
            trigger: getAdControlsTrigger,
            children: (props)=>/*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $3ylo6.default), {
                            ...props,
                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.dismiss",
                                defaultMessage: "Dismiss"
                            })
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $hEz36.default), {
                            ...props,
                            modalProps: {
                                body: /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                    space: "space.150",
                                    children: [
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.why-am-i-seeing-this",
                                                defaultMessage: "We think {offering} will improve your team's productivity. This recommendation is only shown to billing admins and is based on:",
                                                values: {
                                                    offering: offering
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $eyWa4.default), {
                                            as: "ul",
                                            xcss: $b0c1c91ea364c712$var$styles.reasonsUl,
                                            children: [
                                                /*#__PURE__*/ (0, $l998X.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-1",
                                                        defaultMessage: "the size of your team"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $l998X.jsx)("li", {
                                                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                        id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.reason-2",
                                                        defaultMessage: "your existing Atlassian products"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gdv5Z.default), {
                                            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $2Nwuj.default), {
                                                appearance: "default",
                                                href: "https://www.atlassian.com/legal/privacy-policy#what-this-policy-covers",
                                                target: "_blank",
                                                onClick: ()=>fireDismissMenuEvent('clickLink'),
                                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                                                    id: "@atlassian/edition-awareness.edition-awareness-dismiss-button.data-privacy.link",
                                                    defaultMessage: "Learn more about your data privacy with Atlassian"
                                                })
                                            })
                                        })
                                    ]
                                })
                            }
                        })
                    ]
                })
        })
    });
}
module.exports["EditionAwarenessButton"] = $b0c1c91ea364c712$export$57ddd9301662f8e4;
module.exports["EditionAwarenessLink"] = $b0c1c91ea364c712$export$1bf8122badfd728c;

});

parcelRegister("fcmKV", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $3uYxt = parcelRequire("3uYxt");

function $05eecf3c30ec14cd$export$30e224db82597c29(context) {
    const { isInTrial: isInTrial, isInPredunning: isInPredunning, invoiceableStatus: invoiceableStatus, canAddPaymentDetails: canAddPaymentDetails, product: product, edition: edition } = context;
    return Boolean((isInTrial || isInPredunning) && edition === 'standard' && invoiceableStatus === 'NOT_INVOICEABLE' && canAddPaymentDetails && (0, $3uYxt.isProductOneOf)(product, [
        'jira',
        'confluence'
    ]) && (0, $dh538.fg)('ea_to_osb_kill_switch'));
}
module.exports["isEligibleForEAtoOSBExperiment"] = $05eecf3c30ec14cd$export$30e224db82597c29;

});

parcelRegister("3uYxt", function(module, exports) {
function $0784861260cfbf50$export$fda637a5d76f2dc6(product, possibleMatches) {
    return possibleMatches.includes(product);
}
module.exports["isProductOneOf"] = $0784861260cfbf50$export$fda637a5d76f2dc6;

});

parcelRegister("6m14E", function(module, exports) {
const $8d914a23d1ad963b$var$PRODUCT_TO_TRANSLATION_KEY = {
    jira: 'jira',
    'jira-service-management': 'jsm',
    'jira-product-discovery': 'jpd',
    confluence: 'confluence'
};
function $8d914a23d1ad963b$export$fd45d905638d9909(product) {
    return $8d914a23d1ad963b$var$PRODUCT_TO_TRANSLATION_KEY[product];
}
module.exports["getProductForTranslation"] = $8d914a23d1ad963b$export$fd45d905638d9909;

});

parcelRegister("7iPhi", function(module, exports) {
function $676385392b564073$export$8057dcbab6360925(context) {
    const { storageUsageInGB: storageUsageInGB, storageLimitInGB: storageLimitInGB, storageIsUnlimited: storageIsUnlimited, product: product, edition: edition, isInCollection: isInCollection } = context;
    if (!storageUsageInGB || !storageLimitInGB) return false;
    return !isInCollection && product === 'jira' && edition === 'free' && !storageIsUnlimited && storageUsageInGB >= storageLimitInGB;
}
module.exports["isEligibleForStorageHardLimit"] = $676385392b564073$export$8057dcbab6360925;

});

parcelRegister("fTb0L", function(module, exports) {
function $e43506c97bd21691$export$d8e323470f628b52(context) {
    const { product: product, edition: edition, invoiceableStatus: invoiceableStatus, isInReverseTrial: isInReverseTrial, isInTrial: isInTrial, isInPredunning: isInPredunning, isInCollection: isInCollection } = context;
    return Boolean(!isInCollection && product === 'confluence' && edition === 'premium' && (isInTrial || isInPredunning) && isInReverseTrial && invoiceableStatus === 'NOT_INVOICEABLE');
}
module.exports["isEligibleForConfluenceBuyReverseTrialExperiment"] = $e43506c97bd21691$export$d8e323470f628b52;

});

parcelRegister("59Upg", function(module, exports) {
function $6cc140b2c476eaa8$export$948aef0b9bedfdf5(context) {
    const { product: product, edition: edition, hasPaymentDetailsEntered: hasPaymentDetailsEntered, isInCollection: isInCollection, canUpgrade: canUpgrade, userId: userId, changeOfferingToStandardExperienceUrl: changeOfferingToStandardExperienceUrl, transactionAccountId: transactionAccountId, entitlementId: entitlementId } = context;
    return Boolean(!isInCollection && // Eligibility criteria
    product === 'confluence' && edition === 'free' && hasPaymentDetailsEntered === true && canUpgrade === false && // Verify that the data needed to send the request is available
    Boolean(userId) && Boolean(changeOfferingToStandardExperienceUrl) && Boolean(transactionAccountId) && Boolean(entitlementId));
}
module.exports["isEligibleForConfluenceEndUserRequestExperiment"] = $6cc140b2c476eaa8$export$948aef0b9bedfdf5;

});

parcelRegister("7cyOE", function(module, exports) {
function $86655d558d7edfb6$export$e8dada0cc6b0ffe9(context) {
    const { edition: edition, isInTrial: isInTrial, invoiceableStatus: invoiceableStatus, userRoles: userRoles, lastKnownTrial: lastKnownTrial, product: product } = context;
    return Boolean(product === 'confluence' && (edition === 'standard' || edition === 'premium') && isInTrial && invoiceableStatus === 'INVOICEABLE' && userRoles?.includes('SITE_ADMIN') && lastKnownTrial?.trialType === 'MANUAL_TRIAL');
}
module.exports["isEligibleForManualFeatureOnboarding"] = $86655d558d7edfb6$export$e8dada0cc6b0ffe9;

});

parcelRegister("4WriN", function(module, exports) {

var $dh538 = parcelRequire("dh538");

function $44c5f50c534858f4$export$c2752a06dd72a480({ product: product, edition: edition, isSiteEligibleToServcoUplift: isSiteEligibleToServcoUplift, userRoles: userRoles, isInTrial: isInTrial, isInPredunning: isInPredunning }) {
    if (!(0, $dh538.fg)('add_servco_uplift_touchpoint_topnav')) return false;
    const isJSM = product === 'jira-service-management';
    const isStandardOrPremium = edition === 'standard' || edition === 'premium';
    const isOrgAdmin = userRoles?.includes('SITE_ADMIN') ?? false;
    const isSiteEligible = isSiteEligibleToServcoUplift === true;
    const isInTrialOrPredunning = isInTrial || isInPredunning;
    const isNotInTrialOrPredunning = !isInTrialOrPredunning;
    const isEligible = isJSM && isStandardOrPremium && isSiteEligible && isOrgAdmin && isNotInTrialOrPredunning;
    return isEligible;
}
module.exports["isEligibleForServCoUplift"] = $44c5f50c534858f4$export$c2752a06dd72a480;

});

parcelRegister("e2ROq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6Co6F = parcelRequire("6Co6F");


var $eoBBJ = parcelRequire("eoBBJ");

const $6cc51f6f7cb57a0e$var$PRODUCT_TO_ORIGIN = {
    ['confluence']: 'confluence',
    ['jira']: 'jira',
    ['jira-product-discovery']: 'jira',
    ['jira-service-management']: 'jira'
};
function $6cc51f6f7cb57a0e$export$5eea7bde9861e87b(untracedUrl) {
    const { product: product } = (0, $eoBBJ.useEditionAwareness)();
    const origin = (0, $42omo.useMemo)(()=>new (0, $6Co6F.default)({
            product: $6cc51f6f7cb57a0e$var$PRODUCT_TO_ORIGIN[product]
        }), [
        product
    ]);
    const url = (0, $42omo.useMemo)(()=>untracedUrl ? origin.addToUrl(untracedUrl) : undefined, [
        untracedUrl,
        origin
    ]);
    return {
        url: url,
        origin: origin
    };
}
module.exports["useTracedUrl"] = $6cc51f6f7cb57a0e$export$5eea7bde9861e87b;

});

parcelRegister("hT0Mj", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gtD4K = parcelRequire("gtD4K");


var $5RBJ9 = parcelRequire("5RBJ9");

var $2Fndw = parcelRequire("2Fndw");


var $eoBBJ = parcelRequire("eoBBJ");

const $fe17e6b78f72a0b8$var$SpotlightContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(null);
function $fe17e6b78f72a0b8$export$cc7026713a353975() {
    const setActiveSpotlight = (0, $42omo.useContext)($fe17e6b78f72a0b8$var$SpotlightContext);
    if (!setActiveSpotlight) return {
        setActiveSpotlight: ()=>{}
    };
    return {
        setActiveSpotlight: setActiveSpotlight
    };
}
function $fe17e6b78f72a0b8$var$GotIt() {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
        id: "@atlassian/edition-awareness.spotlights.got-it",
        defaultMessage: "Got it"
    });
}
function $fe17e6b78f72a0b8$var$ActiveSpotlight({ id: id, onDismiss: onDismiss }) {
    const { product: product } = (0, $eoBBJ.useEditionAwareness)();
    if (id === 'standard-to-premium') {
        const target = product === 'confluence' ? 'nav-profile' : 'profile-spotlight';
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $2Fndw.default), {
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $5RBJ9.default), {
                actions: [
                    {
                        onClick: onDismiss,
                        text: /*#__PURE__*/ (0, $l998X.jsx)($fe17e6b78f72a0b8$var$GotIt, {})
                    }
                ],
                target: target,
                targetRadius: 3,
                dialogWidth: 275,
                targetBgColor: "var(--ds-elevation-surface-current, #FFFFFF)",
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gtD4K.default), {
                    id: "@atlassian/edition-awareness.spotlight.message",
                    defaultMessage: "Not ready to upgrade? Return to your profile when you're ready."
                })
            })
        });
    }
    return null;
}
function $fe17e6b78f72a0b8$export$c7b90ff96148d0e3({ children: children }) {
    const [activeSpotlight, setActiveSpotlight] = (0, $42omo.useState)(null);
    const handleOnDismiss = (0, $42omo.useCallback)(()=>setActiveSpotlight(null), []);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $l998X.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)($fe17e6b78f72a0b8$var$SpotlightContext.Provider, {
                value: setActiveSpotlight,
                children: children
            }),
            activeSpotlight && /*#__PURE__*/ (0, $l998X.jsx)($fe17e6b78f72a0b8$var$ActiveSpotlight, {
                id: activeSpotlight,
                onDismiss: handleOnDismiss
            })
        ]
    });
}
module.exports["useSpotlight"] = $fe17e6b78f72a0b8$export$cc7026713a353975;
module.exports["Spotlights"] = $fe17e6b78f72a0b8$export$c7b90ff96148d0e3;

});

parcelRegister("04kvJ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $lAJUP = parcelRequire("lAJUP");


var $9x4nt = parcelRequire("9x4nt");


var $4u5NT = parcelRequire("4u5NT");


var $2n68y = parcelRequire("2n68y");

const $c2899783eac96921$export$e926676385687eaf = ({ children: children, product: product, edition: edition, id: id })=>{
    const handleOnError = (0, $2n68y.useErrorAnalytics)({
        product: product,
        edition: edition,
        id: id
    });
    const ufoContext = (0, $9x4nt.useInteractionContext)();
    const onError = (0, $42omo.useCallback)((error)=>{
        const interaction = (0, $4u5NT.getActiveInteraction)();
        handleOnError(error);
        if (interaction && ufoContext) (0, $4u5NT.addError)(interaction?.id, error.name, ufoContext?.labelStack, 'interaction error', error.message, error.stack);
        else (0, $4u5NT.addErrorToAll)(`ErrorBoundary:${id}`, ufoContext?.labelStack || null, 'interaction error', error.message);
    }, [
        handleOnError,
        id,
        ufoContext
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAJUP.ErrorBoundary), {
        onError: onError,
        fallback: /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {}),
        children: children
    });
};
module.exports["ErrorBoundary"] = $c2899783eac96921$export$e926676385687eaf;

});

parcelRegister("2n68y", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $cNaCU = parcelRequire("cNaCU");

/**
 * This hook is designed to be used before contexts are initialized to avoid circular dependencies.
 */ function $4f61c4f554a2ab1f$var$useOperationalFailureAnalytics({ product: product, edition: edition }) {
    const sendOperationalEvent = (0, $cNaCU.useOperationalAnalytics)({
        product: product,
        edition: edition
    });
    return (0, $42omo.useCallback)((attributes)=>{
        sendOperationalEvent({
            action: 'failed',
            actionSubject: '@atlassian/edition-awareness.edition-awareness',
            attributes: attributes
        });
    }, [
        sendOperationalEvent
    ]);
}
/**
 * These are errors which we ignore from SLO reporting to ensure we reporting on errors we can action
 */ const $4f61c4f554a2ab1f$var$nonSLOErrors = [
    /**
	 * These occur when the fetch request fails (usually this is because the users network is offline)
	 *
	 * This is usually thrown from inside of the products fetch handler
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws this error to every fetch request
	 */ /failed to fetch/i,
    /**
	 * These occur when the fetch request fails due to a server response (e.g. 401 due to the user needing to reauthenticate their session)
	 * e.g. jira/src/packages/platform/utils/fetch/src/utils/requests.tsx adds the handler which throws server errors after parsing the response headers
	 */ /Error server response:/i
];
function $4f61c4f554a2ab1f$var$isSLOError(error) {
    // Just checks that none of our non slo errors match the error
    return !$4f61c4f554a2ab1f$var$nonSLOErrors.some((msg)=>msg.test(error.message));
}
function $4f61c4f554a2ab1f$export$e2d4523bbccd2343({ product: product, edition: edition, id: id }) {
    const sendOperationalFailure = $4f61c4f554a2ab1f$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $42omo.useCallback)((error)=>{
        sendOperationalFailure({
            error: error.message,
            errorStack: error.stack,
            errorName: error.name,
            id: id ?? 'unknownErrorId',
            isSLOError: $4f61c4f554a2ab1f$var$isSLOError(error)
        });
    }, [
        sendOperationalFailure,
        id
    ]);
}
function $4f61c4f554a2ab1f$export$45aafd752da9ba22({ product: product, edition: edition }) {
    const sendOperationalFailure = $4f61c4f554a2ab1f$var$useOperationalFailureAnalytics({
        product: product,
        edition: edition
    });
    return (0, $42omo.useCallback)((dataValidationError)=>{
        sendOperationalFailure({
            dataValidationError: dataValidationError,
            id: 'dataValidationError'
        });
    }, [
        sendOperationalFailure
    ]);
}
module.exports["useErrorAnalytics"] = $4f61c4f554a2ab1f$export$e2d4523bbccd2343;

});

parcelRegister("cNaCU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $ac7kz = parcelRequire("ac7kz");

function $b727ae5c33a2fa00$export$18e9461e904f638a({ product: product, edition: edition }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)(({ action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId, attributes: attributes })=>{
        const event = createAnalyticsEvent({
            eventType: 'operational',
            action: action,
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            attributes: {
                ...(0, $ac7kz.defaultAttributes),
                product: product,
                currentProductEdition: edition,
                ...attributes
            }
        });
        const contextAttributes = (0, $ac7kz.getAttributesFromContexts)(event.context);
        event.update({
            attributes: {
                ...contextAttributes,
                ...event.payload.attributes
            }
        }).fire((0, $ac7kz.ANALYTICS_CHANNEL));
    }, [
        createAnalyticsEvent,
        product,
        edition
    ]);
}
module.exports["useOperationalAnalytics"] = $b727ae5c33a2fa00$export$18e9461e904f638a;

});


//# sourceMappingURL=EditionAwarenessUpsell.237a021f.js.map
